import { IconProps } from "../IconProps";

export const IconHeart24 = ({ className, color = "#FFF" }: IconProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.21915C10.0007 2.85535 6.65975 2.12484 4.1547 4.28936C1.64964 6.45389 1.29697 10.0728 3.2642 12.6329C4.89982 14.7613 9.84978 19.2504 11.4721 20.7034C11.6536 20.8659 11.7443 20.9472 11.8502 20.9791C11.9426 21.007 12.0437 21.007 12.1361 20.9791C12.242 20.9472 12.3327 20.8659 12.5142 20.7034C14.1366 19.2504 19.0865 14.7613 20.7221 12.6329C22.6894 10.0728 22.3797 6.43112 19.8316 4.28936C17.2835 2.14761 13.9993 2.85535 12 5.21915Z"
        fill={color}
      />
    </svg>
  );
};
